import { render, staticRenderFns } from "./investigationPlanDetail.vue?vue&type=template&id=0d0a241b"
import script from "./investigationPlanDetail.vue?vue&type=script&lang=js"
export * from "./investigationPlanDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d0a241b')) {
      api.createRecord('0d0a241b', component.options)
    } else {
      api.reload('0d0a241b', component.options)
    }
    module.hot.accept("./investigationPlanDetail.vue?vue&type=template&id=0d0a241b", function () {
      api.rerender('0d0a241b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/investigationPlanDetail.vue"
export default component.exports